<template>
  <div>
    <!-- <item-detail-bar
      back-title="Organization"
      :back-route="{ name: 'users' }"
      :editing.sync="editing"
      :manage-access="hasPermission(10003)"
      @submit="submit"
      @delete="deleteDialog = true"
    ></item-detail-bar>

    <confirm-dialog v-model="deleteDialog" @delete="deleteUser"></confirm-dialog>

    <div class="container page-content">
      <div class="columns">
        <div class="column is-12 is-8-widescreen is-6-fullhd">
          <user-form v-model="user" :editing="editing"></user-form>
        </div>
      </div>
    </div> -->
    <div class="container page-conte">
      Lorem ipsum dolor, sit amet consectetur adipisicing elit. Deserunt
      dignissimos, temporibus laudantium laboriosam adipisci eius neque
      cupiditate, ducimus cum magnam voluptatem numquam sunt nulla quo animi,
      iste voluptate modi nobis?
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import ItemDetailBar from '@/components/ItemDetailBar.vue';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import UserForm from '@/components/forms/UserForm.vue';

export default {
  name: 'DivisionShow',
  components: { ItemDetailBar, ConfirmDialog, UserForm },
  data() {
    return {
      user: {
        roles: [
          {
            roleID: null
          }
        ]
      },
      originalUser: {},
      editing: false,
      deleteDialog: false
    };
  },
  mounted() {
    this.axiosRequest('get', `Users/${this.$route.params.id}`)
      .then(response => {
        this.user = response.data;
        this.originalUser = _.cloneDeep(this.user);
      })
      .catch(error => {
        this.showErrorMessage(error);
      });
  },
  methods: {
    submit() {
      this.axiosRequest(
        'put',
        `Users/${this.$route.params.id}`,
        _.pick(this.user, ['userID', 'firstName', 'lastName', 'email'])
      )
        .then(response => {
          const diff = this.detailedDiff(
            this.user.roles,
            this.originalUser.roles,
            'roleID'
          );
          //console.log(response.data);
          let promises = [];
          if (diff.removed.length > 0) {
            promises = promises.concat(
              diff.removed.map(el =>
                this.axiosRequest(
                  'delete',
                  `Users/${this.user.userID}/Roles/${el.userRoleID}`
                )
              )
            );
          }
          if (diff.added.length > 0) {
            promises = promises.concat(
              diff.added.map(el =>
                this.axiosRequest('post', `Users/${this.user.userID}/Roles`, {
                  userID: this.user.userID,
                  roleID: el.roleID,
                  groupID: el.groupID,
                  applyDefaultPermissions: true
                })
              )
            );
          }
          return Promise.all(promises);
        })
        .then(response => {
          this.editing = false;
        })
        .catch(error => {
          this.showErrorMessage(error);
        });
    },
    deleteUser() {
      this.axiosRequest('delete', `Users/${this.user.userID}`)
        .then(() => {
          this.$router.replace({ name: 'users' });
          this.deleteDialog = false;
        })
        .catch(error => {
          this.showErrorMessage(error);
        });
    }
  }
};
</script>

<style lang="scss"></style>
